import { isAdminUserEmail } from "@-/dev.improve.haniverse.lib.admin.entities";
import { useAuthSession } from "@-/dev.improve.haniverse.lib.auth.client";

/** Authenticated admins only, including on staging and development builds. */
export function useAdminAccess(): boolean {
  const { user } = useAuthSession();
  return isAdminUserEmail(user?.email);
}
